/*
Repo: https://github.com/TeamWertarbyte/material-ui-snackbar-provider/tree/master
* Why this is extracted here: To make support for MUI latest version, repo owner did not have updates
*/

import React, { PureComponent } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';

const SnackbarContext = React.createContext(null);

function DefaultSnackbar({ message, action, ButtonProps, SnackbarProps }) {
  return (
    <Snackbar
      {...SnackbarProps}
      message={message || ''}
      action={
        action != null && (
          <Button color="secondary" size="small" {...ButtonProps}>
            {action}
          </Button>
        )
      }
    />
  );
}

class SnackbarProvider extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      open: false,
    };
    this.contextValue = {
      showMessage: this.showMessage,
    };
  }

  /**
   * Display a message with this snackbar.
   * @param {string} message message to display
   * @param {string} [action] label for the action button
   * @param {function} [handleAction] click handler for the action button
   * @param {any} [customParameters] custom parameters that will be passed to the snackbar renderer
   * @param {function} [handleHideWithoutAction] handler function that is called when the snackbar hides and the action button was not clicked
   * @public
   */
  showMessage = (
    message,
    action,
    handleAction,
    customParameters,
    handleHideWithoutAction,
  ) => {
    this.setState({
      open: true,
      message,
      action,
      handleAction,
      customParameters,
      handleHideWithoutAction,
    });
  };

  handleActionClick = () => {
    this.setState({
      open: false,
      handleAction: null,
      handleHideWithoutAction: null,
    });

    // eslint-disable-next-line react/destructuring-assignment
    this.state.handleAction();
  };

  handleHideWithoutAction = () => {
    const { handleHideWithoutAction } = this.state;
    this.setState({
      open: false,
      handleAction: null,
      handleHideWithoutAction: null,
    });
    if (handleHideWithoutAction) {
      handleHideWithoutAction();
    }
  };

  render() {
    const { action, message, open, customParameters } = this.state;

    const {
      ButtonProps = {},
      children,
      SnackbarProps = {},
      SnackbarComponent = DefaultSnackbar,
    } = this.props;

    return (
      <>
        <SnackbarContext.Provider value={this.contextValue}>
          {children}
        </SnackbarContext.Provider>
        <SnackbarComponent
          message={message}
          action={action}
          ButtonProps={{ ...ButtonProps, onClick: this.handleActionClick }}
          SnackbarProps={{
            ...SnackbarProps,
            open,
            onClose: this.handleHideWithoutAction,
            autoHideDuration:
              customParameters && 'autoHideDuration' in customParameters
                ? customParameters.autoHideDuration
                : SnackbarProps.autoHideDuration,
          }}
          customParameters={customParameters}
        />
      </>
    );
  }
}

function useSnackbar() {
  return React.useContext(SnackbarContext);
}

export { SnackbarProvider, useSnackbar };
